export default {
      id: "pen-white-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pen-white",
      toString: function () {
        return this.url;
      }
    }